import type { UserRole } from "@/types/users";

export type ICompanyChangeRequest = {
  id: number;
  userId: number;
  userName: string;
  userRole: UserRole;
  requestType: RequestType;
  status: RequestStatus;
  adminResponse: string;
  currentCompanyId: number;
  currentCompanyName: string;
  requestedCompanyId: number;
  requestedCompanyName: string;
  isOtherCompany: true;
  newCompanyName: string;
  comment: string;
  createdAt: string;
  processedAt: string;
  processedBy: number;
  processedByName: string;
};

export enum RequestType {
  FlagWrong = "FLAG_WRONG",
  ChangeCompany = "CHANGE_COMPANY",
}

export enum RequestStatus {
  Pending = "PENDING",
  Approved = "APPROVED",
  Rejected = "REJECTED",
  Cancelled = "CANCELLED",
}
